import React from "react";
import { useState } from "react";

// import "../../../index.scss";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import { func } from "prop-types";
import * as XLSX from "xlsx";

import CustomerManageApi from "../../../apis/Customer.api";
import pushApi from "../../../apis/Push.api";
import userApi from "../../../apis/User.api";
import {
  setLoading,
  setSearchText,
  setSelectOrder,
} from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

export default function CustomerListComponent() {
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [pageSize, setPageSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [orderBy, setOrderBy] = useState("desc");
  const [orderType, setOrderType] = useState("payment_created_at");
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const [customerList, setCustomerList] = useState([]);
  const [totalCustomerList, setTotalCustomerList] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [mediaResult, setMediaResult] = useState(null);
  const [mobileColumn, setMobileColumn] = useState(false);
  const [dateType, setDateType] = useState("1week");
  const [selectedData, setSelectedData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchOptions, setSearchOptions] = useState({
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });

  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
  ];

  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);
      if (!matchQueryList.matches) {
        setMobileColumn(false);
      }

      const media = function handleChange(e) {
        setMediaResult(e.matches);
        if (!e.matches) {
          setMobileColumn(false);
        }
      };

      matchQueryList.addEventListener("change", media);
    }
  }, []);
  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  // 리스트 불러오기
  const getCustomerList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      res = await CustomerManageApi.togetherCustomerList(
        type === "initial" || type === "search" ? 0 : offset,
        type === "initial" || type === "search" ? 10 : pageSize,
        //
        type === "initial"
          ? moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm")
          : searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
        type === "initial"
          ? moment().endOf("day").format("YYYYMMDDHHmm")
          : searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
        null,
        "name",
        "desc",
      );

      // 성공
      if (res.code === 200) {
        setIsLoading(false);
        setCustomerList(res.result.userList);
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      console.log("getCustomerListError", error);
    }
  };
  useEffect(() => {
    getCustomerList("initial");
  }, []);

  const columns = [
    {
      title: "성함",
      width: 130,
      dataIndex: "name",
      key: "name",
      align: "center",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const count = value.slice(0, 1) + "*" + value.slice(2);
          return count;
        }
      },
    },
    {
      title: "가입일",
      width: 200,
      dataIndex: "created_at",
      key: "created_at",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD.");
          return date;
        }
      },
    },
    {
      title: "최근로그인시각",
      width: 380,
      dataIndex: "last_login_date",
      key: "last_login_date",
      align: "center",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:MM:SS");
          return date;
        }
      },
      // // sorter: (a, b) => {},
    },
    {
      title: "로그인 횟수",
      width: 160,
      dataIndex: "login_count",
      key: "login_count",
      ellipsis: true,
      fixed: mediaResult ? "" : "left",
      align: "center",
      render: (value) => {
        if (value !== null) {
          const count = value.toLocaleString();
          return count;
        }
      },
    },
    // {
    // 	title: "획득 골드",
    // 	width: 160,
    // 	dataIndex: "earn_gold",
    // 	key: "earn_gold",
    // 	ellipsis: true,
    // 	align: "center",
    // 	fixed: mediaResult ? "" : "left",
    // },
    {
      title: "보유 골드",
      width: 160,
      dataIndex: "gold",
      key: "gold",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
      render: (value) => {
        if (value !== null) {
          const gold = value.toLocaleString();
          return gold;
        }
      },
    },
  ];

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    console.log(pageNumber);
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset(0);
    setCurrentPageNumber(1);
  };
  useEffect(() => {
    getCustomerList();
  }, [offset, pageSize]);

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getCustomerList("search");
      }
    }
  };
  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    setSelectedRowKey([]);
    setSelectedRow([]);
    getCustomerList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("updated_at");
        setOrderBy("desc");
      }
    }
  };
  // let pageList = [];
  let userList = [];
  const [rowSelectArr, setRowSelectArr] = useState([]);
  const [xlsData, setXlsData] = useState([]);
  const [currPage, setCurrPage] = useState([]);
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedData(selectedRows);
      // test([{ page: currentPageNumber }, selectedRows]);
      // customerList.forEach((ele) => {
      // 	if (ele.id === selectedRows.id) {
      // 		userList.push(...xlsData, ele);
      // 		setXlsData(userList);
      // 	}
      // });
      // xlsData.filter((x) => x.id === selectedRows.id);
    },
  };
  // function test(data) {
  // 	if (currPage.includes(currentPageNumber)) {
  // 		xlsData.filter((ele) => ele[0].page !== currentPageNumber);
  // 		userList.push(...xlsData, data);
  // 	} else {
  // 		pageList.push(data[0].page);
  // 		userList.push(...xlsData, data);
  // 	}
  // 	setXlsData(userList);
  // 	setCurrPage(pageList);
  // 	console.log(currPage, data[0].page, "🐰");
  // 	console.log(xlsData, "🥕");
  // }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    let excelData;
    if (selectedData?.length > 0) {
      setIsLoading(true);
      excelData = selectedData.map((row) => {
        return {
          name: row.name,
          login_count: `${row.login_count.toLocaleString()}`,
          gold: `${row.gold.toLocaleString()}`,
          last_login_date: moment(row.last_login_date).format(
            "YYYY.MM.DD HH:MM:SS",
          ),
          created_at: moment(row.created_at).format("YYYY.MM.DD."),
        };
      });
      if (excelData?.length) {
        setIsLoading(false);
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);
        Object.keys(excelData[0]).forEach((key, idx) => {
          const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
          ws[cellAdd].v = status.togetherCustomerKey[key];
        });
        XLSX.utils.book_append_sheet(wb, ws, "당영투게더_고객내역");
        XLSX.writeFile(
          wb,
          `${moment().format("YYYYMM")}_당영투게더_고객내역.xlsx`,
        );
      }
    } else {
      alert(
        "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
      );
      throw "no data";
    }
  };

  return (
    <>
      <ContentHeaderComponent title="고객조회" />
      {/* 조회 기간 */}
      <div className="product-register-wrap">
        <div className="product-search-box-wrap together">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            id={`body-mobile`}
          >
            <Row align={"middle"} style={{ gap: 5 }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/* 고객목록 */}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span
              className="product-register-box-title"
              style={{ fontWeight: 600 }}
            >
              고객목록
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={customerList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey={"id"}
            rowClassName="customer-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              pageSize={pageSize}
              showSizeChanger
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
}
